export default __webpack_public_path__ + "navigation-examples-custom-segue-thumbnail-480-3afe4c5fcb86ccb9ada2eb809c259578.png";